<template>
  <div class="search-style">
    <el-form :model="searchReform" label-width="80px" label-position="left">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="品类：" label-width="50px">
            <el-cascader
              class="data-cascader"
              ref="cascaderRefs"
              @change="handleChange"
              v-model="searchReform.productClassId"
              :options="proClassList"
            ></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="品牌：" label-width="50px">
            <el-select
              @change="changeBrand"
              v-model="searchReform.brandIds"
              clearable
              filterable
              multiple
            >
              <el-option
                v-for="item in brand"
                :key="item.id"
                :label="item.brandName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="4">
          <el-form-item label="系列组：" label-width="68px">
            <el-select
              v-model="searchReform.seriesGroupId"
              filterable
              clearable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
            >
              <el-option
                v-for="item in productGroup"
                :key="item.id"
                :label="item.bgName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>-->
        <el-col :span="6">
          <el-form-item label="系列：" label-width="50px">
            <el-select
              v-el-select-loadmore="loadmore"
              v-model="searchReform.seriesIds"
              multiple
              clearable
              placeholder="全部"
              filterable
            >
              <el-option v-for="item in series" :key="item.id" :label="item.label" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="属地：" label-width="50px">
            <el-select v-model="searchReform.productTerritory" clearable placeholder="全部">
              <el-option
                v-for="item in productTerritoryList"
                :key="item.productTerritory"
                :label="item.title"
                :value="item.productTerritory"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top:20px !important;">
        <el-col :span="6">
          <el-form-item label="产品类型：" label-width="70px" style="width:100%;">
            <el-select v-model="searchReform.productType" clearable placeholder="全部">
              <el-option
                v-for="item in productListType"
                :key="item.proType"
                :label="item.title"
                :value="item.proType"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="是否停产：" label-width="70px">
            <el-select v-model="searchReform.isStop" clearable placeholder="全部">
              <el-option
                v-for="(item,index) in statusList"
                :key="index"
                :label="item.title"
                :value="item.isStop"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label-width="0px">
            <el-input placeholder="输入产品名称/型号/型号别称/订货号" v-model="searchReform.searchKey"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label-width="0px" style="text-align:left;">
            <el-button type="primary" @click="searchFor">搜索</el-button>
            <el-button @click="searchForReset">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin-top:20px;" :gutter="20">
        <el-col :span="24" style="text-align: right;">
          <el-form-item>
            <el-button @click="addProduct">添加产品</el-button>
            <el-button @click="leadInProduct" v-show="activeName==='temporaryProduct'">导入产品</el-button>
            <el-button
              @click="onBatchOffOrLine"
              v-show="activeName==='online'||activeName==='offline'|| activeName===
              'temporaryProduct'"
            >{{activeName==='online'?'批量下线':'批量上线'}}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-------------- 停用或启用品牌 -------------->
    <open-or-close
      ref="OpenOrClose"
      @onUpdataState="onUpdataState"
      :title="title"
      :content="content"
    ></open-or-close>
    <!-- 导入产品 -->
    <lead-in @onRefresh="onRefresh" ref="leadInRefs"></lead-in>
  </div>
</template>

<script>
//  brandGroup,
import {
  brandQueryPageAll,
  onOffProductLineBatchDown,
  querySeriesByMultiBrandId,
  onOffProductLineBatchUp,
  queryProductImport,
  queryAllBrandWithBrandSeries
} from '@/api/product/productManage'
import {
  productTerritoryList,
  productList,
  statusList
} from '@/views/product/utils/data'
import OpenOrClose from '@/components/OpenOrClose/index'
import leadIn from '@/components/leadIn/index'
import { deepClone } from '@/util'
export default {
  name: 'search',
  props: ['searchReform', 'activeName', 'pitchOnList'],
  components: {
    'open-or-close': OpenOrClose,
    'lead-in': leadIn
  },
  directives: {
    'el-select-loadmore': {
      bind (el, binding) {
        // 获取element-ui定义好的scroll盒子
        const SELECTWRAP_DOM = el.querySelector(
          '.el-select-dropdown .el-select-dropdown__wrap'
        )
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          const condition =
            this.scrollHeight - this.scrollTop <= this.clientHeight
          if (condition) {
            binding.value()
          }
        })
      }
    }
  },
  data () {
    return {
      currentPage: 1,
      pageSize: 30,
      brand: [], // 品牌类型
      series: [], // 系列类型
      key: undefined, // 模糊查询
      productGroup: [], // 系列组
      productTerritoryList: [], // 产品属地
      productList: [], // 产品类型
      productListType: [], // 产品类型
      statusList: [], // 是否停产
      proClassList: [], // 品类
      title: '', // 批量上线下线标题
      content: '', // 批量上线下线内容
      arrList: ''
    }
  },
  created () {
    this.key = ''
    // this.queryProductGroup() // 初始化系列组选择器
    this.query() // 初始化品牌列表选择器
    this.getProductClass() // 初始化产品分类信息级联数据
    this.productTerritoryList = productTerritoryList
    this.productListType = productList
    this.statusList = statusList
  },
  methods: {
    onRefresh () {
      this.$emit('getList')
    },
    leadInProduct () {
      queryProductImport().then((res) => {
        if (res.data.code === 200) {
          this.$refs.leadInRefs.onLeadIn(
            this.$store.state.productGuidIn,
            '产品-批量导入'
          )
        } else {
          this.$message.error('暂无权限！')
        }
      })
        .catch((err) => {
          console.log(err)
        })
    },
    handleChange (value) {
      if (value !== undefined) {
        if (value.length !== 3) {
        } else {
          this.getAllBrandWithBrandSeries(value[2])
        }
      }

      // console.log(this.searchReform.productClassId)
    },
    changeBrand (val) {
      const strl = val.join(',')
      this.arrList = strl
      this.searchReform.seriesIds = []
      this.getSupplierList(strl)
    },
    // 系列加载 根据品牌id加载 系列seriesList
    getSupplierList () {
      querySeriesByMultiBrandId(this.currentPage, this.pageSize, this.arrList)
        .then((res) => {
          if (res.data.code === 200) {
            if (this.currentPage === 1) {
              this.series = res.data.obj.records
            } else {
              const arrList = res.data.obj.records
              this.series = this.series.concat(arrList)
            }
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 滚动加载更多
    loadmore () {
      this.currentPage++
      this.getSupplierList()
    },
    remoteMethod (query) {
      this.key = query
      // this.queryProductGroup()
    },
    searchForReset () {
      this.$emit('update:searchReform', {})
      this.$emit('searchFor', {})
      this.searchReform.productClassId = []
      this.$refs.cascaderRefs.$refs.panel.activePath = []
      this.series = []
    },
    getAllBrandWithBrandSeries (id) {
      queryAllBrandWithBrandSeries(id)
        .then((res) => {
          if (res.data.code === 200) {
            this.productList = res.data.obj.baseVoList // 品牌初始化
            // this.productList.forEach((item) => {
            //   item.isActive = undefined
            //   item.isActive = false
            // })
            this.seriesList = res.data.obj.brandSeriesSelectVosList // 系列初始化
            // this.seriesList.forEach((item) => {
            //   item.isActive = undefined
            //   item.isActive = false
            // })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 查询全部类型
    query () {
      // 品牌列表
      brandQueryPageAll()
        .then((res) => {
          if (res.data.code === 200) {
            this.brand = res.data.obj
          }
        })
        .catch((err) => {
          console.log(err)
        })
      // // 系列列表
      // seriesInformation()
      //   .then((res) => {
      //     if (res.data.code === 200) {
      //       this.series = res.data.obj
      //     }
      //   })
      //   .catch((err) => {
      //     console.log(err)
      //   })
    },
    // queryProductGroup () {
    //   // 查询系列组
    //   brandGroup(this.key)
    //     .then((res) => {
    //       if (res.data.code === 200) {
    //         this.productGroup = res.data.obj
    //         this.key = undefined
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //     })
    // },
    // 模糊查询系列组
    search () {
      // this.queryProductGroup()
    },
    // 添加产品
    addProduct () {
      this.$emit('addProduct')
    },
    // 搜索
    searchFor () {
      this.$emit('searchFor', JSON.parse(JSON.stringify(this.searchReform)))
    },
    // 查看产品分类信息
    async getProductClass () {
      this.proClassList = await this.$queryAllProductClassForCascader()
    },
    // 批量上线下线弹窗
    onBatchOffOrLine () {
      if (this.pitchOnList.length < 1) {
        this.$message.warning(
          this.activeName === 'online'
            ? '请选择需要下线的产品!'
            : '请选择需要上线的产品!'
        )
      } else {
        if (this.activeName === 'online') {
          this.title = '产品下线'
          this.content = '确定下线所选产品？'
        } else {
          this.title = '产品上线'
          this.content = '确定上线所选产品？'
        }
        this.$refs.OpenOrClose.onInitial()
      }
    },
    // 批量上线下线调用接口
    onUpdataState () {
      const ids = deepClone(this.pitchOnList).map((i) => i.id).join(',')
      // const state = this.activeName === 'online' ? 0 : 1 // state=1批量上线,0批量下线
      if (this.activeName === 'online') {
        onOffProductLineBatchDown(ids, 0)
          .then((res) => {
            if (res.data.code === 200) {
              this.$message.success('批量下线成功!')
              this.$emit('searchFor', this.searchReform)
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        onOffProductLineBatchUp(ids, 1)
          .then((res) => {
            if (res.data.code === 200) {
              this.$message.success('批量上线成功!')
              this.$emit('searchFor', this.searchReform)
              this.$emit('changeName', 'online')
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    }
  }
}
</script>
